import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import { ManageService } from "../services/Services";

export const useGetSubAccountInfo = (platform, user) => {
    const [kycData, setKycData] = useState(null);
    const [isLoadingFetch, setIsLoadingFetch] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const fetchKycData = useCallback(async () => {
        setIsLoadingFetch(true);
        setErrorMessage(null);

        try {
            const kycDataResult = await ManageService.getCryptoSubAccountCryptofacil(platform);

            console.log("kycDataResult", kycDataResult);

            if (user?.zinliData?.email || user?.zinliData?.phone || kycDataResult) {
                setKycData(kycDataResult);
                return kycDataResult;
            }

            await ManageService.setZinliData({ email: user?.email, phone: user?.phone, idUsr: user?.idUsr });
            refetch();
        } catch (error) {
            toast.error(error.message);
            setErrorMessage(error.message);
        } finally {
            setIsLoadingFetch(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [platform, user]);

    const refetch = () => {
        const response = fetchKycData();
        return response;
    };

    useEffect(() => {
        fetchKycData();
    }, [fetchKycData]);

    return { kycData, isLoadingFetch, errorMessage, refetch };
};
